import { render, staticRenderFns } from "./GeneralKasbon.vue?vue&type=template&id=bc2fb3c8"
import script from "./GeneralKasbon.vue?vue&type=script&lang=js"
export * from "./GeneralKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports